"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _noop2 = _interopRequireDefault(require("lodash/noop"));
var _capitalize2 = _interopRequireDefault(require("lodash/capitalize"));
var _Sidebar = _interopRequireDefault(require("../Sidebar"));
var _Icons = require("../Icons");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function Layout(_ref) {
  var logoSara = _ref.logoSara,
    sidebarItems = _ref.sidebarItems,
    activeRoute = _ref.activeRoute,
    onChangeRoute = _ref.onChangeRoute,
    userFullName = _ref.userFullName,
    userBranch = _ref.userBranch,
    logout = _ref.logout,
    _ref$showSidebar = _ref.showSidebar,
    showSidebar = _ref$showSidebar === void 0 ? true : _ref$showSidebar,
    children = _ref.children,
    _ref$contentClassName = _ref.contentClassName,
    contentClassName = _ref$contentClassName === void 0 ? '' : _ref$contentClassName,
    _ref$headerClassName = _ref.headerClassName,
    headerClassName = _ref$headerClassName === void 0 ? '' : _ref$headerClassName;
  var handleLogout = (0, _react.useCallback)(function () {
    logout();
  }, [logout]);
  var goToWhatsapp = function goToWhatsapp() {
    window.open('https://api.whatsapp.com/send/?phone=5215579721730&text&type=phone_number&app_absent=0', '_blank');
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "layout container-fluid"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "row row-header ".concat(headerClassName)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "col col-header"
  }, logoSara ? /*#__PURE__*/_react["default"].createElement(_Icons.LogoSara, {
    height: "60%"
  }) : /*#__PURE__*/_react["default"].createElement(_Icons.CasanovaLogo, null)), /*#__PURE__*/_react["default"].createElement("div", {
    className: "col col-header col-header-right"
  }, userFullName && /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-header-user mr-3"
  }, /*#__PURE__*/_react["default"].createElement("p", null, userFullName), userBranch && /*#__PURE__*/_react["default"].createElement("p", {
    className: "branch text-secondary text-left"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "font-weight-bold mr-2"
  }, "Sucursal ", (0, _capitalize2["default"])(userBranch)))), /*#__PURE__*/_react["default"].createElement(_Icons.Power, {
    width: "1.5rem",
    height: "1.5rem",
    className: "pointer",
    onClick: handleLogout
  }), /*#__PURE__*/_react["default"].createElement(_Icons.Logo, {
    width: "4.5rem",
    height: "4.5rem",
    style: {
      marginLeft: '1.125rem'
    }
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    id: "something",
    className: "row flex-nowrap"
  }, showSidebar ? /*#__PURE__*/_react["default"].createElement(_Sidebar["default"], {
    activeRoute: activeRoute,
    items: sidebarItems,
    onChangeRoute: onChangeRoute
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "container-fluid content ".concat(contentClassName)
  }, children)) : /*#__PURE__*/_react["default"].createElement("div", {
    className: "container-fluid content ".concat(contentClassName)
  }, children)));
}
Layout.propTypes = {
  sidebarItems: _propTypes["default"].array,
  activeRoute: _propTypes["default"].object,
  onChangeRoute: _propTypes["default"].func,
  userFullName: _propTypes["default"].string.isRequired,
  userBranch: _propTypes["default"].string,
  logoSara: _propTypes["default"].bool,
  logout: _propTypes["default"].func,
  contentClassName: _propTypes["default"].string,
  headerClassName: _propTypes["default"].string
};
Layout.defaultProps = {
  sidebarItems: [],
  onChangeRoute: _noop2["default"],
  logoSara: false,
  logout: _noop2["default"]
};
var _default = exports["default"] = Layout;